import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleDown, faBed, faPlane  } from "@fortawesome/free-solid-svg-icons";
import { withTranslation } from 'react-i18next'; 


class CardHeader extends React.Component {
    constructor (props) {
        super(props)    

        // Binding
        this.handleClick = this.handleClick.bind(this); 
        this.handleClickGoToDestination = this.handleClickGoToDestination.bind(this);
        this.ToggleDealDetails = this.ToggleDealDetails.bind(this);
    }

    handleClick = (e) => {
        e.preventDefault();
        
        this.props.ShowCardLine(true)
    }


    handleClickGoToDestination = (event,click_location) => {
        this.props.GoToDestination(event, click_location);
    }

    ToggleDealDetails = (event) => {
        this.props.ToggleDealDetails(event);
    }

    render() {
        const item = this.props?.data;
        
        if (this.props?.type=='hotels')
            return (
                <a href={this.props?.target_url}  title={this.props.t('deals.cardHeader.allDealsTo')+item.destinations?.city[0]?.name} style={{textDecoration:'none', color:'#fff'}}>
                    <div className={"photo hotel"}
                        style={(this.props?.source=='homepage'?{height:'200px',backgroundImage:`url(https://cdn.cookiecrumbz.com/images/properties/400/${item?.property?.photos?.slice(0,1)})`}:{backgroundImage:`url(https://cdn.cookiecrumbz.com/images/properties/400/${item?.property?.photos?.slice(0,1)})`})}
                        onClick={e=>this.ToggleDealDetails(e)}>

                        <div className="topbar">
                            <div className="title" style={this.props?.source=='homepage'?{fontSize:'0.9em'}:{}} >
                                    <div className='country'>{item.destinations?.country[0]?.name}</div>
                                    <div className='city'>{item.destinations?.city[0]?.name}</div>
                            </div>
                            <div className="features">
                                <span className={"weekend " + ((item?.weekend_il)?'show':'hide')}>{this.props.t('deals.cardHeader.weekendDeal')}</span>
                                {
                                    // Show holidays
                                    item?.holidays?.map((item, index) => {
                                            return item ? (<span className="holiday" key={item+index}>{item}</span>) : null
                                    })
                                }
                                <span className="special-icon black-friday"><img src="/images/icons/black-friday.png" alt={this.props.t('deals.cardHeader.blackFriday')}></img></span>
                            </div>

                        </div>


                        <div className="titleBottom">
                            <h3 title={this.props.t('deals.cardHeader.hotelWithStars', { name: item?.property?.name, stars: item?.property?.stars })}>
                                {item?.property?.name} <span className="stars">{this.getStarsImage(item?.property?.stars)} </span></h3>
                        </div>
                    </div>
                </a>
            )
        else
            return (
                <div className={"photo destination"}
                     style={{backgroundImage:`url(https://cdn.cookiecrumbz.com/images/destinations/${this.props.city_uid}.jpg)`}}
                     alt={this.props.t('deals.cardHeader.dealImageAlt', { destination: `${this.props?.city} (${this.props?.country})` })}>
                    <div className="topbar">
                        <a href={this.props?.target_url}  title={this.props.t('deals.cardHeader.allDealsTo')+this.props?.city} style={{textDecoration:'none', color:'#fff'}}>
                            <div className="title" style={this.props?.source=='homepage'?{fontSize:'0.9em'}:{}} >
                                    <div className="country">{this.props?.country}</div>
                                    <div className="city">{this.props?.city}</div>
                            </div>
                        </a>
                        <div className="features">
                            <span className={"weekend " + ((item?.weekend_il)?'show':'hide')}>{this.props.t('deals.cardHeader.weekendDeal')}</span>
                            {
                                // Show holidays
                                item?.holidays?.map((item, index) => {
                                        return item ? (<span className="holiday" key={item+index}>{item}</span>) : null
                                })
                            }
                            <span className="special-icon black-friday"><img src="/images/icons/black-friday.png" alt={this.props.t('deals.cardHeader.blackFriday')}></img></span>
                        </div>
                    </div>
                    <div className="card-header-title-reverse" style={{display:'flex',  flexDirection:'column', height:'100%'}}>
                        {/*<img src="/images/promotions/blackfriday2025/card.png" alt="מבצע ל48 שעות בלבד - מגן ביטול חופשה בתוספת $1 בלבד בכפוף לתנאי השירות" style={{marginLeft:'1px'}}></img>*/}
                        <div className="titleBottom">
                            <div title={this.props.t('deals.cardHeader.flightHotelPackage')}>
                                <div className="flightIcon">
                                    <div style={{inline:`block`}} className="icon"><FontAwesomeIcon icon={faPlane} className="card-header-plane-rotated" /></div>
                                    <p style={{fontSize:'.9em'}}>{this.props.t('deals.cardHeader.flight')}</p>
                                </div>

                                <div className="plusIcon" style={{fontSize:'1.5em', margin:'0 .1em 0 .3em'}}>+</div>

                                <div className="hotelIcon">
                                    <div style={{inline:`block`}} className="icon"><FontAwesomeIcon icon={faBed} /></div>
                                    <p style={{fontSize:'.9em'}}>{this.props.t('deals.cardHeader.hotel')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        )
    }

    getStarsImage(num) {
        let output = "";

        for (let i=0;i<num;i++) {
            output+="★";
        }

        return output;
    }
}

export default withTranslation()(CardHeader)